import { render } from "./App.vue?vue&type=template&id=f706808e"
const script = {}
script.render = render

export default script